
import './src/scss/_style.scss';

import RSTitleSearch from './src/js/RSTitleSearch';
import Search from './src/js/Search';

document.addEventListener('DOMContentLoaded', () => {
	Search.init(document.querySelector(`.search-popup`));
});

export {
	RSTitleSearch
};